export const DATA_TYPE = {
  /*
  AIRPORT: "AIRPORT",
  LANDMARK: "LANDMARK",
  DISTRICT: "CITY",
  CITY: "CITY",
  STATE: "STATE",
  COUNTRY: "COUNTRY",
  WORLD: "WORLD",
  */
}

export const GTM_EVENT_CATEGORY = {
  /*
  Place the GTM EVENT CATEGORYs here

  Sample below:

  AFFORDABLE: "Affordable Hotels Carousel",
  POPULAR: "Popular Hotels Carousel",
  GENERAL: "General Listing Hotels Carousel",
  DISCOUNT: "Discounted Hotels Carousel",

  COUNTRY_LOCATION: "Country",
  STATE_LOCATION: "State",
  CITY_LOCATION: "City",
  DISTRICT_LOCATION: "District",
  LANDMARK_LOCATION: "Landmark",
  AIRPORT_LOCATION: "Airport",
  */
}

export const GTM_PROJECT_CATEGORY = "SEO-FOOD"
export const BASE_URL =
  process.env.GATSBY_ENV === "stg" || process.env.GATSBY_ENV === "dev"
    ? "https://www.stgairasia.com/food/city"
    : "https://www.airasia.com/food/city"
